import apiUrl from '../../../constants'
import axios from 'axios'
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import ScheduledList from './ScheduledList/index.vue';
import UnScheduledList from './UnScheduledList/index.vue';
import searchNetworkTrip from './searchNetworkTrip/index.vue';
import EBNTracking from './EBNTracking/index.vue';

export default {
  name: 'network-management',
  components: {
		DatePicker,
		'first': UnScheduledList,
		'second': ScheduledList,
		'third': searchNetworkTrip,
		'fourth': EBNTracking,
	},
	props: [],
	data() {
		return {
			currentTab: 'First',
			componentKey: 0,
			tabs: [{
					key: 'First',
					value: 'Unscheduled List'
				},
				{
					key: 'Second',
					value: 'Scheduled List'
				},
				{
					key: 'third',
					value: 'Search Trip'
				},
				{
					key: 'Fourth',
					value: 'EBN Tracking'
				}
			],
		}
	},
	computed: {
		// selects all checkbox's option
		currentTabComponent: function() {
			this.componentKey += 1
			return this.currentTab.toLowerCase()
		}
	},
	mounted() {},
	methods: {}
}



// WEBPACK FOOTER //
// ./src/views/components/NetworkManagement/NetworkManagement.js